var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c(
        "b-table",
        {
          ref: "generalTables",
          staticClass: "dm-paginated-table",
          attrs: {
            id: "generalTable",
            "current-page": 0,
            fields: _vm.fields,
            filter: _vm.filter,
            "filter-included-fields": _vm.activatedFilter,
            items: _vm.data,
            "per-page": 0,
            "sort-by": _vm.sortBy,
            "sort-desc": _vm.sortDesc,
            "sort-direction": _vm.sortDirection,
            "show-empty": "",
            small: "",
            striped: "",
            responsive: _vm.responsive,
            "head-variant": _vm.headVariant,
            busy: _vm.isBusy,
            "tbody-tr-class": _vm.tbodyTrClass,
          },
          on: {
            "update:sortBy": function ($event) {
              _vm.sortBy = $event
            },
            "update:sort-by": function ($event) {
              _vm.sortBy = $event
            },
            "update:sortDesc": function ($event) {
              _vm.sortDesc = $event
            },
            "update:sort-desc": function ($event) {
              _vm.sortDesc = $event
            },
            filtered: _vm.filtered,
          },
          scopedSlots: _vm._u(
            [
              {
                key: "table-busy",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "text-center text-danger my-2" },
                      [
                        _c("b-spinner", {
                          staticClass: "align-middle",
                          attrs: { variant: "primary", label: "Spinning" },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "cell(actions)",
                fn: function (row) {
                  return [
                    _c(
                      "div",
                      { staticClass: "dm-paginated-table-actions" },
                      [
                        _vm._t("image", null, { row: row }),
                        _vm._t("action", null, { row: row }),
                        _vm.showActionButtons &&
                        _vm.showUpdateButtom &&
                        (!_vm.verifyAdminUser ||
                          !row.item.createdByAdmin ||
                          _vm.userProfile === "admin_sistema" ||
                          _vm.isMaster)
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    value: {
                                      fallbackPlacement: "clockwise",
                                      title: _vm.$t("editar"),
                                    },
                                    expression:
                                      "{\n            fallbackPlacement: 'clockwise',\n            title: $t('editar')\n          }",
                                    modifiers: { hover: true },
                                  },
                                ],
                                staticClass: "mr-1 mb-1",
                                attrs: {
                                  size: "sm",
                                  variant: "outline-primary",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.info(row.item)
                                  },
                                },
                              },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "pencil", variant: "primary" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.showActionButtons &&
                        _vm.showDeleteButtom &&
                        (!_vm.verifyAdminUser ||
                          !row.item.createdByAdmin ||
                          _vm.userProfile === "admin_sistema" ||
                          _vm.isMaster)
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    value: {
                                      fallbackPlacement: "clockwise",
                                      title: _vm.$t("excluir"),
                                    },
                                    expression:
                                      "{\n            fallbackPlacement: 'clockwise',\n            title: $t('excluir')\n          }",
                                    modifiers: { hover: true },
                                  },
                                ],
                                staticClass: "mr-1 mb-1",
                                attrs: {
                                  size: "sm",
                                  variant: "outline-danger",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.remove(row.item._id)
                                  },
                                },
                              },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "trash", variant: "danger" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                },
              },
              {
                key: "empty",
                fn: function () {
                  return [
                    _c("div", { staticClass: "text-center" }, [
                      _vm._v(" " + _vm._s(_vm.$t("semregistros")) + " "),
                    ]),
                  ]
                },
                proxy: true,
              },
              _vm._l(Object.keys(_vm.$scopedSlots), function (slotName) {
                return {
                  key: slotName,
                  fn: function (slotScope) {
                    return [_vm._t(slotName, null, null, slotScope)]
                  },
                }
              }),
            ],
            null,
            true
          ),
        },
        [_vm._t("overrideActions")],
        2
      ),
      _vm.showPagination
        ? _c(
            "b-col",
            { staticClass: "my-1", attrs: { md: "12", sm: "6" } },
            [
              _c("b-pagination", {
                staticClass: "my-0",
                attrs: {
                  "per-page": _vm.localLimit,
                  "total-rows": _vm.localTotalRows,
                  align: "center",
                  "aria-controls": "generalTable",
                  size: "sm",
                },
                on: { input: _vm.get },
                model: {
                  value: _vm.localPage,
                  callback: function ($$v) {
                    _vm.localPage = $$v
                  },
                  expression: "localPage",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }